module.exports = __webpack_public_path__ + "static/img/8bg_7.ca43720.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_7.png
// module id = 767
// module chunks = 1